/* eslint-disable */

import Vue from 'vue'
import testStoreModule from './store'
import Config from '../../../config'
import axiosIns from './axios'

import EventBus from '@/libs/EventBus'

import helpers from '@/libs/helpers.js'

const storeNameSpace = 'testStore'


import AssetsPreload from './AssetsPreload'

window.preload = new AssetsPreload()


function createTestApp(options) {
    const { router, store } = options

    const http = axiosIns({
        BASE_URL: Config.apiUrl,
        store
    })

    return new Vue({
        router,
        store,
        data() {
            return {

                uploads: [],
                THEME_DEFAULT: 'blank',
                timeCounter: 0,
                startTiming: false, // Cờ đếm thòi gian
                autoSave: null
            }
        },
        async created() {
            
        },
        methods: {

            convertAudioHtml (html) {

                /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/
                while (true) {

                    const indexFirstAudioTag = html.indexOf('<audio src')

                    if (indexFirstAudioTag == -1) {
                        break;
                    }

                    const indexLastAudioTag = html.substring(indexFirstAudioTag).indexOf('</audio>') + indexFirstAudioTag;
    
                    let audioHtml = html.substring(indexFirstAudioTag, indexLastAudioTag);
    
                    let audioSrc = audioHtml.substring(audioHtml.indexOf(`src=`) + 6)
                    audioSrc = audioSrc.substring(0, audioSrc.indexOf('"') - 1);
                    
                    let audioElement = `
                    <div class=\\"audio no-replay\\">
                        <div class=\\"d-flex border card flex-row p-2 shadow mt-2 align-items-center\\">
                            <button>
                                <svg class=\\"play-icon\\" viewBox=\\"0 0 24 24\\" width=\\"24\\" height=\\"24\\" stroke=\\"currentColor\\" stroke-width=\\"2\\" fill=\\"none\\" stroke-linecap=\\"round\\" stroke-linejoin=\\"round\\"><circle cx=\\"12\\" cy=\\"12\\" r=\\"10\\"></circle><polygon points=\\"10 8 16 12 10 16 10 8\\"></polygon></svg>
                                <svg class=\\"pause-icon\\" viewBox=\\"0 0 24 24\\" width=\\"24\\" height=\\"24\\" stroke=\\"currentColor\\" stroke-width=\\"2\\" fill=\\"none\\" stroke-linecap=\\"round\\" stroke-linejoin=\\"round\\"><circle cx=\\"12\\" cy=\\"12\\" r=\\"10\\"></circle><line x1=\\"10\\" y1=\\"15\\" x2=\\"10\\" y2=\\"9\\"></line><line x1=\\"14\\" y1=\\"15\\" x2=\\"14\\" y2=\\"9\\"></line></svg>
                            </button>
                            <div class=\\"ms-2 w-100\\">
                                <div class=\\"d-flex justify-content-between\\">
                                    <p><strong>Bài nghe</strong></p>
                                    <p class=\\"audio-time\\">00:00 / 00:00</p>
                                </div>
                                <p class=\\"alert small text-mute\\">Bạn chỉ được nghe 01 lần, khi đã sẵn sàng bấm play để nghe</p>
                            </div>
                        </div>
                        <audio>
                            <source src=\\"${audioSrc}\\" type=\\"audio/mpeg\\">
                            Your browser does not support the audio element.
                        </audio>
                    </div>`;

                    html = `${html.substring(0, indexFirstAudioTag)}${audioElement.replace(/\n/g, '').replace(/\s\s+/g, '')}${html.substring(indexLastAudioTag + 8, html.length)}`;
    
                }
                return html;
            },

            _getAssetsFromExamData (examData) {
                const assets = []
                while (new RegExp(['http://', 'https://'].join('|')).test(examData)) {
                    let indexOf = -1
                    indexOf = examData.indexOf('http://')
        
                    if (indexOf == -1)
                        indexOf = examData.indexOf('https://')
        
                    if (indexOf != -1) {
                        examData = examData.substr(indexOf)
                        let assetLink = examData.substr(0, examData.indexOf('\"'))
                        examData = examData.substr(examData.indexOf('\"'))
    
    
                        // remove "/" ở cuối link
                        if (assetLink.substr(assetLink.length - 1) == "\\") {
                            assetLink = assetLink.substr(0, assetLink.length - 1)
                        }
        
                        assets.push(assetLink)
                    }
                }
                return assets
            },
    

            getStartWith () {
                return this.$store.getters[`${storeNameSpace}/getStartWith`]
            },

            getTestResult () {
                return new Promise((resolve) => {

                    const testId = this._getHistoryId()
                    
                    http.get(http.ENDPOINT.GET_TEST_RESULT, {
                        params: {
                            test_id: testId
                        }
                    }).then(resp => {
                        resolve(resp.data.data)
                    })

                })
            },

            _autoSave () {
                setTimeout( () => {
                    if (this.startTiming) {
                        this.testSave()
                        this._autoSave()
                    }
                }, 30000)
            },
            _autoSaveWriting() {
                setTimeout(() => {
                    if (this.getQuestionOfPart().part_type == 1) {
                        if (this.startTiming) {
                            this.saveWriting(0)
                            this._autoSaveWriting()
                        }
                    }
                }, 60000)
            },
            async saveWriting(value = null ,overlay = false ){
                
                return new Promise((resolve, reject) => {

                    http.post(http.ENDPOINT.SAVE_WRITING, {
                        trackid: this._getTracking(),
                        id: this.getQuestionOfPart().id,
                        data: this.getQuestionOfPart().writing,
                        id_writing : this._getHistoryId(),
                        check_submit : value
                    }, {
                        page_overlay: overlay
                    })
                    .catch(error => {
                        this.$bvToast.toast(error.message, {
                            title: `Có lỗi xảy ra !`,
                            variant: 'danger',
                            solid: true
                        })
                        reject(error.message) 
                    })
                })
                
            },
            qAnswer(questionId, answer) {
                this.$store.commit(`${storeNameSpace}/SET_ANSWER`, {
                    id: questionId,
                    value: answer
                })
            },

            getTimeCouter() {
                return this.timeCounter
            },

            setTimeCountDown () {
                const questionOfPart = this.getQuestionOfPart()

                if (questionOfPart) {
                    if (questionOfPart.time_remaining) {
                        this.timeCounter = questionOfPart.time_remaining
                    } else {
                        this.timeCounter = questionOfPart.time
                    }
                    this.startTiming = true
                }
            },

            countDownTimer() {
                setTimeout(() => {
                    if (this.startTiming) {
                        this.timeCounter -= 1
                        this.$store.commit(`${storeNameSpace}/SET_TIME_REMAINING`, this.timeCounter)
    
                        // Khi hết thời gian
                        if (this.timeCounter <= 0) {
                            if (this.getQuestionOfPart().part_type == 2) {
                                window.EventBus.$emit('TIME_UP')
                            } else {
                                this.nextPart()
                            }
                            this.startTiming = false
                        }
                    }
                    this.countDownTimer()
                }, 1000)
            },

            goToPage (page) {
                if (page) {
                    this.$store.commit(`${storeNameSpace}/SET_PAGE`, page)
                }
                this.$nextTick(()=>{ 
                    setTimeout(() => {
                        window.scrollTo(0, 0);

                        this.appendAudioControl()
                        
                    }, 500)
                })
            },

            formatSecondsAsTime(secs) {
                var hr  = Math.floor(secs / 3600);
                var min = Math.floor((secs - (hr * 3600))/60);
                var sec = Math.floor(secs - (hr * 3600) -  (min * 60));
    
                if (min < 10){ 
                    min = "0" + min; 
                }
                if (sec < 10){ 
                    sec  = "0" + sec;
                }
    
                return min + ':' + sec;
            },

            appendAudioControl () {

                document.querySelectorAll('audio').forEach(el => {

                    const timeElement = el.parentNode.querySelector('.audio-time')
                    if (timeElement) {
                        timeElement.textContent = `00:00 / ${this.formatSecondsAsTime(el.duration)}`;
                    }

                    el.addEventListener('canplay', (event) => {
                        if (timeElement) {
                            timeElement.textContent = `00:00 / ${this.formatSecondsAsTime(event.target.duration)}`;
                        }
                    })
        
        
                    el.addEventListener('timeupdate', (event) => {
                        if (timeElement) {
                            timeElement.textContent = `${this.formatSecondsAsTime(event.target.currentTime)} / ${this.formatSecondsAsTime(event.target.duration)}`;
                        }
                    })
                })
        
        
                document.querySelectorAll('.audio.no-replay button').forEach(e => {
        
                    if (!e.hasAttribute('inited')) {
        
                        e.setAttribute('inited', true)
        
                        e.addEventListener('click', () => {
        
                            const audio = e.parentNode.parentNode.querySelector('audio')
                            if (audio) {
                                if (e.parentNode.parentNode.classList.contains('play')) {
                                    audio.pause()
                                    e.parentNode.parentNode.classList.remove('play')
                                } else {
                                    if (audio.currentTime == audio.duration && audio.played.length == 1) {
                                        return
                                    }
                                    //stop all audio
                                    document.querySelectorAll('.audio.no-replay.play button').forEach(e => {
                                        e.click()
                                    })
                                    audio.play()
                                    e.parentNode.parentNode.classList.add('play')
                                }
                            }
                        })
                    }
                    
                })
            },


            nextPage () {
                let currentPage = this.getPageCurrent()
                this.goToPage(++currentPage)
            },

            getPageCurrent() {
                return this.$store.state[storeNameSpace].page
            },

            goToPart (part) {
                console.log(part)
                if (part != undefined){
                    this.$store.commit(`${storeNameSpace}/SET_PART`, part)
                }
            },
            
            async nextPart () {
                
                
                let currentPart = this.getPartCurrent()
                const pageLength = this._getExam().part.length - 1

                if (this.getQuestionOfPart().part_type == 1) {
                    this.saveWriting(1)
                }
                // chưa đến part cuối
                // save lại bài làm
                // Chuyển qua part tiếp theo
                if (pageLength > currentPart) {
                    
                    this.goToPart(++currentPart)
                    const questionOfPart = this.getQuestionOfPart()
                    if (questionOfPart.time == 0) {
                        this.nextPart()
                        return
                    }
                    this.setTimeCountDown()
                    
                    await this.testSave(true)

                } 
                
                // đã đến part cuối
                // dừng đếm countdown
                // nộp bài thi
                else {
                    this.startTiming = false

                    window.EventBus.$emit('testEnd', Object.keys(this.uploads).length)

                    if (await this.uploadCheck()) {
                        await this.testSave(true)
                        // this.testSubmit()
                        .then(() => {
    
                            window.EventBus.$emit('uploadProcess')
    
                            if (this.getThemeName() == 'prepare') {
                                this.goToPage(8)
                            } else {
                                this.goToPage(7)
                                this.testNewSession()
                            }
                        })
                    } else {
                        window.EventBus.$emit('uploadError')
                    }
                }

                this.$nextTick(() => {
                    this.$bvModal.hide('confirm-next')
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                        this.appendAudioControl()
                    }, 500)
                })
            },

            async reUploadFile (uploadObject) {
                const QuestionId = uploadObject?.question?.id
                const { question, file } = uploadObject
    
                this.saveRecord(question, file)
    
                if (await this.uploadCheck()) {
                    this.testEndSubmit()
                }
            },

            testEndSubmit () {
                this.testSubmit()
                .then(() => {
    
                    window.EventBus.$emit('uploadProcess')
                    
                    if (this.getThemeName() == 'prepare') {
                        this.goToPage(4)
                    } else {
                        this.goToPage(5)
                        this.testNewSession()
                    }
                })
            },
    
            
            uploadCheck () {
                return new Promise((resolve, reject) => {
                    const checkUpload = () => {
                        setTimeout(() => {
    
                            const uploadProgress = this.getUploadProgress()
    
                            console.log('uploadProgress: ', uploadProgress)
            
                            if (uploadProgress.processed == uploadProgress.total) {
                                if (uploadProgress.error == 0) {
                                    resolve(true)
                                } else {
                                    console.log('resolve(false)')
                                    resolve(false)
                                }
                            } else {
                                checkUpload()
                            }
                            
                            window.EventBus.$emit('updateProgress', this.uploads)
                            
                        }, 500)
                    }
    
                    checkUpload()
                })
            },

            testSubmit () {
                return new Promise(async (resolve, reject) => {

                    await this.testSave()

                    http.post(http.ENDPOINT.TEST_SUBMIT, {
                        trackid: this._getTracking(),
                        test_data: this._getExam(),
                        update_resutl: false,
                    })
                    .then(res => {
                        if (res.data.code === 1) {
                            return resolve(res.data.message)
                        } else {
                            return reject(res.data.message)
                        }
                    })
                    .catch(error => {
                        return reject(error.message)
                    })
                })
            },


            testSave(overlay = false) {
                return new Promise((resolve, reject) => {


                    if (!this._getHistoryId() || this._getHistoryId() < 0) {
                        return resolve(false)
                    }

                    http.post(http.ENDPOINT.TEST_SAVE, {
                        trackid: this._getTracking(),
                        test_data: this._getExam(),
                        test_id: this._getHistoryId()
                    }, {
                        page_overlay: overlay
                    })
                    .then(res => {
                        if (res.data.code === 1) {
                            return resolve(true)
                        } else {
                            this.$bvToast.toast(res.data.message, {
                                title: `Có lỗi xảy ra !`,
                                variant: 'danger',
                                solid: true
                            })
                            return reject(res.data.msg)
                        }
                    })
                    .catch (error => {
                        this.$bvToast.toast(error.message, {
                            title: `Có lỗi xảy ra !`,
                            variant: 'danger',
                            solid: true
                        })
                        return reject(error.message)
                    })
                })
            },
            
            getPartCurrent() {
                return this.$store.state[storeNameSpace].part
            },


            // Tiếp tục làm bài thi đang dở
            testContinue (pendingData) {
                if (pendingData) {
                    this._setQuestion(pendingData)
                    this.goToPage(2)
                    this.goToPart(pendingData.partIsUsed)
                }
            },
            testNewSession () {
                // reset ve part 0
                this.goToPart(0)
                const examID = this.$store.getters[`${storeNameSpace}/examID`]
                localStorage.removeItem(`_speakup_exam${examID}`)
            },

            async loadTestInLocal () {
                const questionId = this.$store.state[storeNameSpace].exam.id

                if (questionId) {
                    const testId = localStorage.getItem(`_speakup_exam${questionId}`)

                    if (testId) {
                        this.$store.commit(`${storeNameSpace}/SET_HISTORY_ID`, testId)
                    }
                }
            },

            

            /**
             * Tìm tracking trong localStorage
             * 
             * @returns {string} trackingID
             */
            _getTracking() {
                let tracking = this.$store.state[storeNameSpace].tracking_id
                if (tracking) {
                    return tracking
                }

                tracking = localStorage.getItem('_speakup_track');
                if (tracking) {
                    this._setTracking(tracking)
                    return tracking
                }
            },

            _setTracking(trackId) {
                this.$store.commit(`${storeNameSpace}/SET_TRACKING_ID`, trackId)
            },

            _setQuestion(examData) {
                this.$store.commit(`${storeNameSpace}/SET_QUESTIONS`, examData)
            },

            _preloadExamAsset (examData) {

                const assetsArr = this._getAssetsFromExamData(JSON.stringify(examData))
                window.preload.setAssets(assetsArr).run()
                
                window.preload.onloaded = () => {
                    // this._preloadChangeBlob()
                }
    
            },
    
            _preloadChangeBlob () {
    
                let exam = JSON.stringify(this._getExam())
    
                const preloadList = window?.preload?.assets
    
                for (const asset of preloadList) {
                    exam = exam.split(asset.src).join(asset.blob)
                }
                
                this._setQuestion(JSON.parse(exam))
    
            },
    
            getAssetBlob(url) {
                if (!window.preload) return url
                return window.preload.getBlob(url)
            },
            
    
            convertAssetsToBlob (html) {
    
                const preloadList = window?.preload?.assets
    
                for (const asset of preloadList) {
                    html = html.split(asset.src).join(asset.blob)
                }
    
                return html
            },
    
    
            assetLoadPercent() {
                return preload.getProgress()
            },

            _fetchExam() {

                const examId = this.$route.query['exam']
                const examSlug = this.$route.params.examSlug
                
                const formData = {
                    tracking_id: this._getTracking(),
                }

                if (examId || examSlug) {
                    formData.target = examId ?? examSlug

                    if (examId) {
                        formData.type = 'exam_id'
                    }

                    if (examSlug) {
                        formData.type = 'exam_slug'
                    }
                }
                
                return new Promise((resolve, reject) => {
                    http.get(http.ENDPOINT.GET_EXAM, {
                        params: formData
                    }).then(resp => {
                        if (resp.data.code == 1) {
                            // const examData = resp.data.data
                            // this._setQuestion(examData)
                            // resolve(examData)

                            const examData = resp.data.data
                        
                            // Audio fix 
                            const examAudioConvert = JSON.parse((this.convertAudioHtml(JSON.stringify(examData))))

                            this._setQuestion(examAudioConvert)
                            this._preloadExamAsset(examAudioConvert)
                            resolve(examAudioConvert)
                        }

                        else {
                            this.$store.commit(`${storeNameSpace}/SET_ERROR`, 'INIT_EXAM_ERROR')
                            return reject(false)
                        }
                    })
                    .catch(error => {
                        return reject(error)
                    })
                })
            },

            changeAudioControl() {
                const exam = this._getExam()
                const examAudioConvert = JSON.parse((this.convertAudioHtml(JSON.stringify(exam))))
                this._setQuestion(examAudioConvert)
            },

            _getExamId () {
                return this.$store.state[storeNameSpace].exam.id
            },

            _getExam () {
                return this.$store.state[storeNameSpace].exam
            },

            _getHistoryId () {
                return this.$store.state[storeNameSpace].testHistory.id
            },


            /**
             * 
             * @returns tracking
             */
            async trackingInit() {
                if ( ! this._getTracking() ) {
                    const resp = await http.get(http.ENDPOINT.INIT_TRACKID)
                    if (resp.data.code === 1) {
                        const trackID = resp.data.data
                        this._setTracking(trackID)
                        return trackID
                    }
                    // .then(resp => {
                        
                    // })
                    // .catch(error => {
                    //     return error.message
                    // })
                }
            },

            userInit () {
                const localUserInfo = localStorage.getItem('_speakup_userInfo')
                let userData = {}

                if (localUserInfo) {
                    userData = JSON.parse(localUserInfo || '{}')
                }

                userData.source = document.location.href;
                this.$store.commit(`${storeNameSpace}/SET_CONTACT_INFO`, userData)
            },


            /**
             * Kiem tra bai thi dang làm với mã đề đã config cho trang này
             * 
             */
            checkTestingHistory () {
                return new Promise ((resolve, reject) => {
                    if (this._getHistoryId() < 0 || !this._getHistoryId()) {
                        return resolve(false)
                    }

                    http.get(http.ENDPOINT.GET_EXAM_HISTORY, {
                        params: {
                            trackid: this._getTracking(),
                            id: this._getHistoryId(),
                            cid: this.$store.state[storeNameSpace].contactInfo.id
                        }
                    }).then (resp => {
                        if (resp.data.code === 1) {
                            const testData = resp.data.data
                            // Truong hop bai test chua hoan thanh hoac khong co
                            if (testData.status == 0) {
                                return resolve(testData.test_result)
                            }
                            else {
                                return resolve(false)
                            }
                        } else {
                            return resolve(false)
                        }
                    })
                    .catch (error => {
                        return reject('checkExamPending', error)
                    })
                })
            },


            pageSetting () {
                return new Promise((resolve, reject) => {
                    http.get(http.ENDPOINT.SITE_CONFIG)
                    .then(res => {
                        this.$store.commit(`${storeNameSpace}/SET_SETTINGS`, res.data)

                        return resolve(true)
                    })
                    .catch(err => {
                        reject(err)
                    })
                })    
            },


            siteSettings () {
                return this.$store.state[storeNameSpace].appSettings
            },

            getThemeName () {
                return this.siteSettings().theme || this.THEME_DEFAULT
            },

            getAppLoading () {
                return this.$store.state[storeNameSpace].loading
            },

            checkLogin () {
                const access_token = helpers.getParameterByName('access_token')
                // Nếu url có kèm theo query refresh_token
                if (access_token) {
        
                    this.$cookie.set('access_token', access_token)
        
                    let urlQuery = window.location.search
                    urlQuery = urlQuery.replace('?', '')
                    urlQuery = urlQuery.split('&')
                    for (let index = 0; index < urlQuery.length; index++) {
                        if (urlQuery[index].indexOf('access_token') != -1) {
                            urlQuery.splice(index, 1)
                            break;
                        }
                    }
                    window.history.pushState("", "", `?${urlQuery.join('&')}`);
                }

                this.AuthCheck()
            },

            AuthCheck () {
                const accessToken = this.$cookie.get('access_token')
    
                if (accessToken) {
                    http.get('/GEauth/userinfo', {
                        headers: {
                            'authorization': 'Bearer ' + accessToken
                        }
                    }).then(res => {
                        if (res.data.code == 1) {
                            this.$cookie.set('ctid', res.data.data.id)
                            this.setContactInfo({
                                id: res.data.data.id,
                                email: res.data.data.email,
                                name: res.data.data.displayName
                            })
                        } else {
                            this.$store.dispatch(`${storeNameSpace}/AuthLogout`)
                        }
            
                    })
                } else {
                    this.$store.dispatch(`${storeNameSpace}/AuthLogout`)
                }
            },

            userClearInfo () {
                this.$store.dispatch(`${storeNameSpace}/userClearInfo`)
            },

            getExamRule () {
                const exam = this.$store.state[storeNameSpace].exam

                return exam.rules || ''
            },
            getQuestionOfPart(partNumber) {
                if (partNumber) {
                    return this.$store.state[storeNameSpace].exam.part[partNumber]
                }

                return this.$store.state[storeNameSpace].exam.part[this.getPartCurrent()]
            },

            setContactInfo (data) {
                this.$store.commit(`${storeNameSpace}/SET_CONTACT_INFO`, data)
            },
            
            getContactInfo () {
                return this.$store.getters[`${storeNameSpace}/getContactInfo`]
            },

            pushContact(data) {
                return new Promise((resolve, reject) => {

                    const contact = this.$store.state[storeNameSpace].contactInfo
                    const storeUserInfo = Object.assign(JSON.parse(JSON.stringify(contact)), data)

                    http.post(http.ENDPOINT.PUSH_CONTACT, {
                        trackid: this._getTracking(),
                        data: storeUserInfo
                    })
                    .then(resp => {
                        if (resp.data.code == 1) {
                            const contactId = resp.data.data
                            const userInfo = Object.assign(storeUserInfo, {id: contactId})
                            this.setContactInfo(userInfo)
                            return resolve(userInfo)
                        } else {
                            resolve(false)
                        }
                    })
                    .catch(error => {
                        reject('pushContact', error)
                    })
                })
            },

            pushSurveyForm (data) {
                return new Promise((resolve, reject) => {

                    const contact = this.$store.state[storeNameSpace].contactInfo
                    const storeUserInfo = Object.assign(JSON.parse(JSON.stringify(contact)), data)

                    http.post(http.ENDPOINT.PUSH_SURVEY, {
                        trackid: this._getTracking(),
                        data: storeUserInfo
                    })
                    .then(resp => {
                        if (resp.data.code == 1) {
                            // const contactId = resp.data.data
                            // const userInfo = Object.assign(storeUserInfo, {id: contactId})
                            // this.setContactInfo(userInfo)
                            // return resolve(userInfo)
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    })
                    .catch(error => {
                        reject('pushSurveyForm', error)
                    })
                })
            },

            createTest() {
                return new Promise ((resolve, reject) => {
                    http.post(http.ENDPOINT.TEST_CREATE, {
                        tracking_id: this._getTracking(),
                        exam_id: this._getExamId(),
                    })
                    .then(resp => {
                        if (resp.data.code === 1 ) {
                            this.$store.commit(`${storeNameSpace}/SET_HISTORY_ID`, resp.data.data)
                            return resolve(resp.data.data)
                        } else {
                            return reject(new Error(resp.data.msg || 'Có lỗi xảy ra, vui lòng thử lại!'))
                        }
                    })
                    .catch(error => {
                        return reject(error)
                    })
                })
            },

            pushContactAndCreateTest(data) {
                return new Promise((resolve, reject) => {
                    this.pushContact(data)
                    .then(() => {
                        return this.createTest()
                    })
                    .then( result => {
                        if (result) {

                            this.$analytics.fbq.event('CompleteRegistration', {
                                value: 20.000,
                                currency: 'VND',
                                content_name: 'Signup',
                                status: 'complete'
                            });

                            // chuyen page tiep theo
                            this.nextPage()
                            
                            return resolve(result)
                        }
                        
                        return reject(false)
                    })
                    .catch(error => {
                        return reject(error)
                    })
                })
            },


            writing(content) {
                this.$store.commit(`${storeNameSpace}/SET_WRITING`, content)
            },
            writingOfPart(part) {
                const contentOfPart = this.getQuestionOfPart(part)
                return contentOfPart.writing || ''
            },

            Start() {
                this.nextPage()
                this.setTimeCountDown()
                if (!this.autoSave)
                    this._autoSave()
                    this._autoSaveWriting()
            },



            // speaking


            setVideoReplayCount (video_replay) {
                this.$store.commit(`${storeNameSpace}/SET_VIDEO_REPLAY_COUNT`, video_replay)
            },

            speakingVideo (index) {
                this.$store.commit(`${storeNameSpace}/SET_QUESTION_INDEX`, index)
            },

            speakingStep (step) {
                this.$store.commit(`${storeNameSpace}/SET_PART_STEP`, step)
            },

            getStartType () {
                return this.$store.getters[`${storeNameSpace}/getStartType`]
            },

            getError () {
                return this.$store.getters[`${storeNameSpace}/getError`]
            },


            /**
             * Thống kê các câu hỏi đã làm theo từng part
             * Chỉ thống kê với các part câu hỏi dạng bình thường có part_type = 0
             */
            getPartAnalytic() {
                
                const questionOfPart = this.getQuestionOfPart()

                console.log(questionOfPart)

                if (!questionOfPart) return;
                if (questionOfPart.part_type != 0) return;
                if (questionOfPart.questions.length === 0) return;

                const questions = questionOfPart.questions

                const resultData = {
                    resolve: 0,
                    dontResolve: 0,
                    reReview: 0
                }
                
                for (let index = 0; index < questions.length; index++) {
                    const question = questions[index];
                    

                    // Dạng bài điền vào chỗ trống
                    // Sẽ có nhiều câu hỏi nhỏ trong 1 câu hỏi
                    // Đếm option_data để biết số lượng câu hỏi cụ thể
                    if (question.content_type == 3) {
                        // số lượng câu hỏi
                        const numberQuestion = question.option_data.length
                        
                        // Số lượng câu hỏi đã trả lời
                        const numberQuestionResolve = question.answers.filter(el => el !== '').length

                        const numberQuestionDontResolve = numberQuestion - numberQuestionResolve

                        resultData.resolve += numberQuestionResolve
                        resultData.dontResolve += numberQuestionDontResolve
                        resultData.reReview += numberQuestionDontResolve
                    }

                    // Dang cau hoi dung sai
                    // Chi co 1 cau hoi
                    if (question.content_type == 1) {

                        // Da trả lời câu hỏi
                        if (question.answers.length !== 0) {
                            resultData.resolve += 1
                        }
                        
                        // chưa trả lời câu hỏi
                        else {
                            resultData.dontResolve += 1
                            resultData.reReview += 1
                        }
                    }

                }

                console.log(resultData)

                return resultData

            },

            setVideoPlayCouter (couter) {
                this.$store.commit(`${storeNameSpace}/SET_VIDEO_REPLAY_COUNT`, couter)
            },
            setQuestionIndex(questionIndex) {
                this.$store.commit(`${storeNameSpace}/SET_QUESTION_INDEX`, questionIndex)
            },
            setPartStep(step) {
                this.$store.commit(`${storeNameSpace}/SET_PART_STEP`, step)
            },

            saveRecord (question, audioBlob) {

                const questionId = question?.id

                const formData = new FormData();
                formData.append('audio', audioBlob, `audioRecord-${new Date().getTime()}.mp3`)

                // return new Promise( (resolve, reject) => {
                //     http.post(http.ENDPOINT.UPLOAD, formData, {
                //         headers: {
                //             'Content-Type': 'multipart/form-data'
                //         }
                //     })
                //     .then( (response) => {
                //         if (response.data.code == 1) {
                //             this.qAnswer(questionId, response.data.data.src)
                //             resolve(response)
                //         }
                //     })
                //     .catch((err) => {
                //         reject(err)
                //     } )
                // })


                const uploadPromise =  new Promise( (resolve, reject) => {

                    let startTime, endTime;
    
                    startTime = (new Date()).getTime();
    
                    http.post(http.ENDPOINT.UPLOAD, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: (progressEvent) => {
                            
                            const uploadIndex = this.uploads.findIndex(el => el.questionId == questionId)
                            
                            const nowProcess = (progressEvent.progress * 100).toFixed(1)
                            this.uploads[uploadIndex].progress = nowProcess > 97 ? 97 : nowProcess
    
                            if (progressEvent.progress == 1) {
    
                                endTime = (new Date()).getTime();
                                let duration = (endTime - startTime) / 1000;
                                let bitsLoaded = progressEvent.bytes * 8;
                                let speedBps = (bitsLoaded / duration).toFixed(2);
                                let speedKbps = (speedBps / 1024).toFixed(2);
                                let speedMbps = (speedKbps / 1024).toFixed(2);
    
                            }
                        },
                    })
                    .then( (response) => {

                        const uploadIndex = this.uploads.findIndex(el => el.questionId == questionId)

                        if (response.data.code == 1) {
                            this.uploads[uploadIndex].loaded = true
                            this.uploads[uploadIndex].progress = 100
                            this.qAnswer(questionId, response.data.data.src)
                            resolve(response)
                        } else {
                            this.uploads[uploadIndex].error = true
                        }
    
    
                        this.uploads[uploadIndex].processed = true
                    })
                    .catch((err) => {

                        const uploadIndex = this.uploads.findIndex(el => el.questionId == questionId)

                        this.uploads[uploadIndex].error = true
                        reject(err)
                        this.uploads[uploadIndex].processed = true
                    } )
                })

                const uploadIndex = this.uploads.findIndex(el => el.questionId == questionId)
    

                if (uploadIndex == -1) {
                    this.uploads.push({
                        questionId: questionId,
                        process: uploadPromise,
                        question: question,
                        file: audioBlob,
                        loaded: false,
                        error: false,
                        progress: 0,
                        processed: false
                    })
                }
    
                // Vue.set(this.uploads, questionId, {
                //     process: uploadPromise,
                //     question: question,
                //     file: audioBlob,
                //     loaded: false,
                //     error: false,
                //     progress: 0,
                //     processed: false
                // })

            },

            
            getUpload () {
                return this.uploads
            },
            
            getUploadProgress () {
                const total = Object.keys(this.uploads).length
                let processed = 0
                let error = 0

                for (const [key, upload] of Object.entries(this.uploads)) {
                    if (upload.processed) {
                        processed += 1
                    }

                    if (upload.error) {
                        error += 1
                    }
                }

                return {
                    total,
                    processed,
                    error
                }
            }
        }
    })
}

export default {
    install: (Vue, options = {}) => {
        
        const { store, router } = options

        if (store) {
            store.registerModule(storeNameSpace, testStoreModule)
        }


        if (!Vue.prototype.$TestApp) {
            Vue.prototype.$TestApp = {}
        }

        Vue.prototype.$TestApp = createTestApp({router, store})

        Vue.mixin({
            
        })
    }
}